/* "1 / 3" counter for the Featured + grid product media style. Only shows on mobile, where the gallery swipes. */
(function () {
  if (window.__mediaCounterLoaded) return;
  window.__mediaCounterLoaded = true;

  function init(counter) {
    if (counter.__ready) return;
    var slider = counter.closest('[data-product-main-media]');
    var wrapper = slider && slider.querySelector('[data-main-product-media]');
    if (!wrapper) return;
    counter.__ready = true;

    function update() {
      var slides = wrapper.querySelectorAll(':scope > .swiper-slide');
      var total = slides.length;
      var width = wrapper.clientWidth || 1;
      var index = Math.min(total, Math.max(1, Math.round(wrapper.scrollLeft / width) + 1));
      counter.textContent = index + ' / ' + total;
      counter.hidden = total < 2;
    }

    wrapper.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
    /* A variant change moves that variant's image to the front, so go back to the start. */
    new MutationObserver(function () {
      wrapper.scrollLeft = 0;
      update();
    }).observe(wrapper, { childList: true });
    update();
  }

  function run() {
    document.querySelectorAll('[data-media-counter]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
